/* global axios */
import ApiClient from './ApiClient';

class TelephonyAPI extends ApiClient {
  constructor() {
    super('telephony', { accountScoped: true });
  }

  // Banner: is telephony active for this agent + is their IP Russian.
  networkCheck() {
    return axios.get(`${this.url}/network_check`);
  }
}

export default new TelephonyAPI();
